// var swiper = new Swiper('#t-product-carousel', {
//     slidesPerView: 3,  // Number of slides visible at once
//     spaceBetween: 30,  // Space between slides
//     loop: true,        // Enable looping of slides
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,  // Make pagination clickable
//     },
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//     breakpoints: {
//       768: {
//         slidesPerView: 2, // 2 slides visible on small screens
//       },
//       480: {
//         slidesPerView: 1, // 1 slide visible on mobile screens
//       }
//     }
//   });



var tProductCarousel = new Swiper('#t-product-carousel', {
  // Optional parameters
  direction: 'horizontal',
  freeMode: true,
  clickable: true,
  slidesPerView: 2,
  spaceBetween: 20,
  // autoplay: {
  //   delay: 3000,
  // },
  pagination: {
      el: '.swiper-pagination',
      clickable: true,  // Make pagination clickable
    },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 44
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: 4,
      spaceBetween: 55
    },
  }
});


var tStoriesCarousel = new Swiper('#t-stories-carousel', {
  // Optional parameters
  direction: 'horizontal',
 // clickable: true,
  slidesPerView: 1,
  //spaceBetween: 20,
  autoplay: {
    delay: 3000,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});


var tAboutCarousel = new Swiper('#t-about-carousel', {
  // Optional parameters
  direction: 'horizontal',
  freeMode: true,
  clickable: true,
  slidesPerView: 1,
  spaceBetween: 20,
  // autoplay: {
  //   delay: 3000,
  // },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});